import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { JsonFileService } from '../services/json-file.service';


export class MenuService extends JsonFileService {
    constructor(protected http: Http) { super(http); }

    getFilePath(): string {
        return 'assets/data/menu.json';
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
